import { defineMessages } from "react-intl";

export const messages = defineMessages({
  saleDetailsUnassignCategory: {
    id: "/V7UOC",
    defaultMessage: "Unassign and save",
    description: "unassign category from sale and save, button",
  },
  saleDetailsUnassignCollection: {
    id: "6RtE2D",
    defaultMessage: "Unassign and save",
    description: "unassign collection from sale and save, button",
  },
  saleDetailsUnassignProduct: {
    id: "opIDox",
    defaultMessage: "Unassign and save",
    description: "unassign product from sale and save, button",
  },
  saleDetailsUnassignVariant: {
    id: "Uj2hj8",
    defaultMessage: "Unassign and save",
    description: "unassign variant from sale and save, button",
  },
  saleDetailsUnassignCategoryDialog: {
    id: "GiJm1v",
    defaultMessage:
      "{counter,plural,one{Are you sure you want to unassign this category?} other{Are you sure you want to unassign {displayQuantity} categories?}}",
    description: "dialog content",
  },
  saleDetailsUnassignCollectionDialog: {
    id: "UjoSZB",
    defaultMessage:
      "{counter,plural,one{Are you sure you want to unassign this collection?} other{Are you sure you want to unassign {displayQuantity} collections?}}",
    description: "dialog content",
  },
  saleDetailsUnassignProductDialog: {
    id: "AHK0K9",
    defaultMessage:
      "{counter,plural,one{Are you sure you want to unassign this product?} other{Are you sure you want to unassign {displayQuantity} products?}}",
    description: "dialog content",
  },
  saleDetailsUnassignVariantDialog: {
    id: "iWyoZn",
    defaultMessage:
      "{counter,plural,one{Are you sure you want to unassign this variant?} other{Are you sure you want to unassign {displayQuantity} variants?}}",
    description: "dialog content",
  },
  saleDetailsUnassignDialogDelete: {
    id: "rNzkIt",
    defaultMessage: "Are you sure you want to delete {saleName}?",
    description: "dialog content",
  },
  saleDetailsSaleDelate: {
    id: "4C7I61",
    defaultMessage: "Removed sale",
    description: "sale Details delete button",
  },
  saleDetailsUnassignCategoryDialogHeader: {
    id: "B5yE8S",
    defaultMessage: "Unassign Categories From Sale",
    description: "dialog header",
  },
  saleDetailsUnassignCollectionDialogHeader: {
    id: "0TQuo4",
    defaultMessage: "Unassign Collection From Sale",
    description: "dialog header",
  },
  saleDetailsUnassignProductDialogHeader: {
    id: "n7GIKB",
    defaultMessage: "Unassign Product From Sale",
    description: "dialog header",
  },
  saleDetailsUnassignVariantDialogHeader: {
    id: "Kyyr7D",
    defaultMessage: "Unassign Variant From Sale",
    description: "dialog header",
  },
  saleDetailsSaleDeleteDialog: {
    id: "V3fvcD",
    defaultMessage: "Removed sale",
    description: "dialog content",
  },
  saleDetailsSaleDeleteDialogHeader: {
    id: "1/oG76",
    defaultMessage: "Delete Sale",
    description: "dialog header",
  },
  saleDetailsChannelAvailabilityDialogHeader: {
    id: "SqcGBK",
    defaultMessage: "Manage Channel Availability",
    description: "channel availability dialog header",
  },
  productUnavailable: {
    id: "Uwo+ai",
    defaultMessage: "Product unavailable in discount channels",
  },
});
